var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Box } from "../..";
export var Track = function (_a) {
    var source = _a.source, target = _a.target, getTrackProps = _a.getTrackProps, disabled = _a.disabled, height = _a.height;
    return (React.createElement(Box, { lss: {
            position: 'absolute',
            transform: 'translate(0%, -50%)',
            height: height,
            zIndex: 1,
            bg: disabled ? 'gray200' : 'secondary500',
            borderRadius: 'md',
            cursor: 'pointer',
            left: source.percent + "%",
            width: target.percent - source.percent + "%"
        } },
        React.createElement("div", __assign({}, getTrackProps()))));
};
//# sourceMappingURL=Track.js.map